<ion-header no-border>
  <ion-toolbar>

    <ion-buttons slot="start">
      <ion-button (click)="dismiss()" data-cy="editInput-toolbar-dismiss">
        <ion-icon color="dark" class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title color="primary">Offline Help</ion-title>

  </ion-toolbar>
</ion-header>

<ion-content class="padding">

  <div class="message pad-20">
    <h3>The Open House sign-in on our mobile app still functions when offline, but some of your leads, may not show
      until you're back online.</h3>

    <br /><br />
    If you don't have wifi access, <strong class="link" (click)="openHelp()">here's a link to our Offline Help
      Center</strong> which
    shows how to use
    your
    phone as a hot
    spot to get online.
    <br /><br />

    Our <strong class="link" (click)="openHelp()">Offline Help Center</strong> also includes the features that require
    an internet
    connection and
    details
    the account
    data
    that may not be visible while offline.
    <br /><br />

    <strong>IMPORTANT:</strong> To avoid data loss, <strong>do not uninstall the app</strong> or log out of your
    account while the app is offline. This is especially important if you've been using the Open House sign-in while
    offline.
  </div>

</ion-content>